<div class="flex flex-col gap-1 mt-1">
  <input
    type="text"
    class="bm-input bm-input-sm w-full font-mono"
    placeholder="Scan testen"
    aria-label="Scan testen"
    data-testid="sn-pattern-test-input"
    [value]="scan()"
    (input)="onScanInput($event)"
  />
  @if (result(); as current) {
    @if (current.serialNumber) {
      <small class="text-green-600" data-testid="sn-pattern-test-result">
        SN: <span class="font-mono">{{ current.serialNumber }}</span>
      </small>
    } @else {
      <small class="text-warning" data-testid="sn-pattern-test-result">kein Treffer</small>
    }
  }
</div>
